// @flow
export const isClient = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export const isServer = !isClient



// WEBPACK FOOTER //
// ./src/services/getRenderPlatform.js